import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 30000,
});

// Retry once on network-level errors (cold start / transient network glitches).
// We only retry idempotent methods and network failures (no response received).
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (!cfg || cfg.__retried) return Promise.reject(error);
    const method = (cfg.method || "get").toLowerCase();
    const isSafe = method === "get" || method === "head";
    const noResponse = !error.response;
    if (isSafe && noResponse) {
      cfg.__retried = true;
      await new Promise((res) => setTimeout(res, 800));
      return api.request(cfg);
    }
    return Promise.reject(error);
  }
);

export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

export function formatApiError(err) {
  const data = err?.response?.data;
  const detail = data?.detail;
  if (detail == null) {
    return data?.message || err?.message || "Error inesperado";
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.msg === "string") return detail.msg;
    try { return JSON.stringify(detail); } catch { return "Error inesperado"; }
  }
  return String(detail);
}
